import React, { useEffect, useState } from "react";
import axios from "axios";
import { REACT_APP_API_URL } from "../env.js";

const Notice = () => {
  const [notices, setNotices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${REACT_APP_API_URL}/api/notice/all-notice`)
      .then((res) => {
        setNotices(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching notices:", err);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <p className="text-center py-5">Loading...</p>;
  }

  return (
    <div className="container-fluid px-0">
      <div className="position-relative">
        <img
          src="/images/unsplash2.jpg"
          alt="Notice Banner"
          className="img-fluid w-100"
          style={{ maxHeight: "400px", objectFit: "cover" }}
        />
        <div className="position-absolute top-50 start-50 translate-middle text-white text-center">
          <h2 className="fw-bold d-none d-md-block text-white">Notice & Circulars</h2>
          <h4 className="fw-bold d-md-none text-white">Notice & Circulars</h4>
        </div>
      </div>

      <div className="container-fluid py-4 px-3">
        <div className="d-none d-md-block">
          <div className="table-responsive">
            <table className="table table-bordered table-striped align-middle text-center">
              <thead className="bg-info" style={{ color: "#fff" }}>
                <tr>
                  <th>Notice Date</th>
                  <th className="text-start">Letter No.</th>
                  <th className="text-start">Headline</th>
                  <th>Download</th>
                </tr>
              </thead>
              <tbody>
                {notices.map((notice, idx) => (
                  <tr key={idx}>
                    <td>{new Date(notice.NoticeDate).toLocaleDateString()}</td>
                    <td className="text-start">{notice.LetterNo}</td>
                    <td className="text-start">
                      <p style={{ color: "#007bff" }}>{notice.Headline}</p>
                    </td>
                    <td>
                      <td>
                        {notice.Files?.map((f, i) => (
                          <a
                            key={i}
                            href={`${REACT_APP_API_URL.replace(/\/$/, "")}${f.FilePath}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-sm btn-primary me-1"
                          >
                            View {i + 1}
                          </a>
                        ))}
                      </td>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="d-md-none">
          {notices.map((notice, idx) => (
            <div className="card mb-3" key={idx}>
              <div className="card-body">
                <h5 className="card-title text-dark">{notice.LetterNo}</h5>
                <p className="text-muted mb-1">
                  <strong>Date:</strong>{" "}
                  {new Date(notice.NoticeDate).toLocaleDateString()}
                </p>
                <p>{notice.Headline}</p>
                {notice.Files?.map((f, i) => (
                  <a
                    key={i}
                    href={`${REACT_APP_API_URL.replace(/\/$/, "")}${f.FilePath}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-sm btn-primary me-1"
                  >
                    View {i + 1}
                  </a>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Notice;